<template>
     <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="false"
        :loading="false"
    >
        <template #subHeaderActions>
            <div class="d-flex">
                <Button btn-class="me-3 btn-sm" v-if="advance?.status == 'UNPAID'" @click="openValidateAdvanceModal()" type="submit" btn-text="button.pay" />
                <Button type="cancel"  v-if="advance?.status !== 'CANCEL'"  @click="cancelAdvancePayment()" btn-class="btn-sm me-3" btn-text="button.cancel" ></Button>
                <Button btn-class="me-3 btn-sm" v-if="advance?.status !== 'CANCEL'" @click="openSendModal" type="new" btn-text="crm.invoices.send" />
                <Button icon-class="fas fa-backspace" btn-class="btn-sm" type="cancel" btn-text="crm.back" @click="router.go(-1)"/>
            </div>
        </template>
        <template #layoutContent>
          <Loader :isLoading="isLoading">
            <div class="row d-flex flex-wrap px-5">
                <div class="card p-5 mb-4 me-md-5 flex-grow-1 col-12 col-md-3 col-lg-3">
                    <Button btn-class="me-3 mb-5 btn-sm" @click="goToInvoice(advance?.invoice?.id)" icon-class="fas fa-file" type="new" height="45px" btn-text="invoices.invoice"></Button>

                  <FileUploaded :attach-files="paymentFiles" />
                </div>
                <div class="card card-px-0 px-0 flex-grow-3 flex-md-grow-1 col-12 col-md-3 col-lg-3" style="flex: 1 1 60%;">
                    <Show :advance="advance?.status == 'UNPAID'" :payment="payment" :advancePayment="advance"/>
                    <div class="card-toolbar">
                        <AlertModal v-model:showingAlert="showingAlert" @cancel="cancelSend"/>
                    </div>
                </div>
           </div>
          </Loader>
        </template>
    </SubLayout>
    <SendAdvanceModal id="sendModal" @submit="submitSend" :content="emailFormData" :is-loading="isLoadingSend" :title="$t('crm.payments.sendAdvance')" type="ADVANCE_INVOICE" :file_number="$t('crm.advances.title') +' '+ advance.advance_number"/>
    <ValidateAdvanceModal id="validateAdvanceModal" @load="loadAdvance" :invoiceCurrency="advance?.invoice?.currency"/>
</template>

<script setup>
import { ref, watch, computed, shallowRef, onMounted } from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import { useRouter, useRoute } from 'vue-router';
import Loader from "@/components/Loader";
import Button from "@/components/Button";
import Show from "./components/Show.vue"
import {useSwal} from "@/composables/useSwal";
import {useStore} from "vuex";
import i18n from "@/plugins/i18n";
import {$formatLocalAmount} from "@/mixins/Helpers";
import AlertModal from '@/Modules/CRM/components/Modals/AlertModal.vue';
import { useLocales } from "@/composables/locales";
import ValidateAdvanceModal from "@/Modules/CRM/components/Modals/Advance/validateAdvanceModal.vue"
import OpportunityFilesManagement from "@/Modules/CRM/views/Pipeline/components/OpportunityFilesManagement";
import FileUploaded from "@/components/FileUploaded";
import SendAdvanceModal from "@/Modules/CRM/components/Modals/SendAdvanceModal";

const {locale} = useLocales()
const store = useStore()
const router = useRouter()
const route = useRoute()

const {showSwal} = useSwal()

const isLoading = ref(false)
const title = ref( "payment.advance")
const breadcrumbs = ref([

  {
    name: 'breadcrumbs.advance.detail',
    route: 'payments-view',
    params: route.params.id
  }
])

const emailFormData = shallowRef({
  advanceId: route.params.id,
  body: "",
  subject: i18n.global.t('crm.advances.title'),
  facture: "",
  to: [],
  from: ''
})

const isLoadingSend = ref(false)
const showingAlert = ref(false)

const paymentFiles = ref([])

const advance = computed(() => store.getters['advances/currentAdvancePayment'])
const currency = computed(() => advance.value?.invoice?.currency?.symbol)
const company = computed(() => store.getters['company/getCompanyInfos'])

watch(() => company.value, () => {
  emailFormData.value.from = company.value?.society?.society_email
})

watch(() => advance.value, () => {
    if(advance.value?.invoice?.contact?.email){
        emailFormData.value.to = [advance.value?.invoice?.contact?.email]
    }
})

watch(() => advance.value.paymentFiles, (value) => {
  let data = []
  advance.value.paymentFiles?.map(fileData => {
    let file = fileData.file.split('.')
    let type = getFileType(file[file.length-1])
    data.push({ name: fileData.file, size: fileData.size || 0, url: fileData.file_url, type: type,id:fileData.id })
  })
  paymentFiles.value = data
})

function getFileType(type){
  let mimeType = ''

  switch (type) {
    case 'pdf':
      mimeType = 'application/pdf';
      break;
    case 'doc':
      mimeType = 'application/msword';
      break;
    case 'docx':
      mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      break;
    case 'jpeg':
    case 'jpg':
      mimeType = 'image/jpeg';
      break;
    case 'png':
      mimeType = 'image/png';
      break;
    default:
      mimeType = '';
  }

  return mimeType;
}

function resetData(){
  loadData()
}

function cancelSend(){
    store.dispatch('advances/cancelAdvancePaymentMail',route.params.id)
        .then(() => {
            window.toastr['success'](i18n.global.t('notification.mail_cancelled'))
            showingAlert.value = false;
        })
        .catch(() => {
            showingAlert.value = false;
        })
}

function cancelAdvancePayment(){
    showSwal(
        i18n.global.t('crm.advances.swal.title_cancel'),
        i18n.global.t('crm.advances.swal.cancel')
    ).then( async (result) => {
        if (result.value) {
            try {
                store.dispatch('advances/cancelAdvancePayment', {advance_invoice_id: route.params.id})
                .then(() => {
                    loadAdvance()
                    window.toastr['success'](i18n.global.t('notification.advance_cancelled'))
                })
                .catch(() => {

                })
            }catch (e) {

            }
        }
    });
}

function openValidateAdvanceModal(){
    $('#validateAdvanceModal').modal('toggle')
}

function openSendModal(){
    $('#sendModal').modal('toggle')
}

function goToInvoice(id){
    router.push({ name: 'invoices-view', params: {id: id} })
}

function submitSend() {
    isLoadingSend.value = true
    store.dispatch('advances/sendAdvancePayment', emailFormData.value)
        .then(() => {
            $("#sendModal").modal('toggle');
            loadAdvance()
            emailFormData.value.to = [advance.value?.invoice?.contact?.email]
            window.toastr['success'](i18n.global.t('notification.advance_send'))
            isLoadingSend.value = false
            alertDiv()
        })
        .catch(() => {
            isLoadingSend.value = false
        })
}

function loadAdvance(){
    store.dispatch('advances/getAdvancePaymentById', route.params.id)
}

function loadData () {
  Promise.all([
    loadAdvance(),
    store.dispatch('payments/loadPaymentTypes'),
    store.dispatch('payments/loadPaymentStatus'),
    store.dispatch('company/generalInformation')
  ])
}

onMounted(() => {
  loadData()
})

function alertDiv(){
    showingAlert.value = true;
    $('#sendModal').modal('toggle')
    setTimeout(() => {
        showingAlert.value = false;
      }, 5000);
}
</script>

<style scoped>
    .card-parent {
        position: relative;
    }

    .card-child {
        position: absolute;
        bottom: 0;
        width: 90%;
        font-weight: 500;
        margin-bottom: 20px;
    }
</style>